import type { FaireProductEntity } from "../../entity_types/product";

export const p_x4sg3kehm6: FaireProductEntity = {
  token: "p_x4sg3kehm6",
  type: "product",
  name: "Espresso Martini Frozen Cocktail-Just add Water + Vodka",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/56f0b37fe3d907d7e226831eff843b9b7655d95827311dd1aa51b9deb401dd82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3427863ab6919b0b5f50aa3867021bd3f85865b66b5b290dc96a8f086614476d.png",
    "https://cdn.faire.com/fastly/5d9876ebae5b919125f7ec0c20123424a78bbf141490fa5140ad15f73ddb4644.png",
    "https://cdn.faire.com/fastly/bd57b1578e01f500fcb4cffe87489444ded34d231e1f1d6b3af5225fe53e3e31.png",
  ],
  priceDollars: 8.5,
  description:
    "Frozen Cocktails don't get easier than this! Each bag makes 8 servings. No blenders ever! Simply add 12oz Vodka and 36oz water shake or stir and throw in the freezer. \n\nOur Frozen cocktails are unique in you ONLY ever add water and spirit...NEVER any juice, mixers or additional flavors. That's one of the things that sets us apart. 100% all natural ingredients and perfect to share with friends and family at your next party. Cheers from Noble Mick's\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA 🇺🇸\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and design makes merchandising a breeze!",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:04.251Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
